import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  radioError: {
    color: theme.palette.error.main,
  },
}))

export default styles
